const style = (theme) => {
  const output = {
    root: {
      backgroundColor: '#ededed',
      overflow: 'hidden',
    },
    imageWrapper: {
      position: 'relative',
      zIndex: 1,
      width: '100vw',
      height: '100vh',
      fallbacks: {
        height: '-webkit-fill-available',
      },
      '& img': {
        objectFit: 'cover',
        objectPosition: '50% 50%',
        width: '100%',
        height: '100%',
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        zIndex: 1,
        bottom: -20,
        left: 0,
        width: '100%',
        height: '40vh',
        background: `linear-gradient(180deg, ${theme.getRgba(theme.colors[6], 0.01)} 0%, ${theme.colors[6]} 100%)`,
        fallback: {
          background: theme.colors[8],
        },
      },
    },
    title: {
      zIndex: 2,
    },
    carouselWrapper: {
      padding: [100, 0],
      overflow: 'hidden',
      backgroundColor: '#e9e9e9',
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {}

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {}

  return output
}

export default style
